import 'css-chunksrc/client/common/profileNavigation/menu/styles.scss';export default {
  "menu": "_menu_1m6ba_1",
  "planzone": "_planzone_1m6ba_11",
  "shortLogo": "_shortLogo_1m6ba_21",
  "planzoneName": "_planzoneName_1m6ba_32",
  "navigation": "_navigation_1m6ba_42",
  "item": "_item_1m6ba_49",
  "text": "_text_1m6ba_53",
  "logOut": "_logOut_1m6ba_70",
  "loader": "_loader_1m6ba_88",
  "planzones": "_planzones_1m6ba_93",
  "tick": "_tick_1m6ba_101",
  "planzoneLogo": "_planzoneLogo_1m6ba_110",
  "planzoneItem": "_planzoneItem_1m6ba_118"
};